import CloseIcon from './CloseIcon.jsx';
import RoundedCloseIcon from './RoundedCloseIcon.jsx';
import ArrowLeft from './ArrowLeft.jsx';
import Cart from './Cart.jsx';
import CartAdd from './CartAdd.jsx';
import ItemsIcon from './ItemsIcon.jsx';
import CarIcon from './CarIcon.jsx';
import ArrowRight from './ArrowRight.jsx';
import Crop from './CropIcon';
import TrashIcon from './TrashIcon'
import DropdownClosedIcon from './DropdownClosedIcon'
import DropdownOpenedIcon from './DropdownOpenedIcon'
import NoteIcon from './NoteIcon';
import Star from './Star';
import NextIcon from './NextIcon';
import BackIcon from './BackIcon';
import ThreeDots from './ThreeDots';
import Pencil from './Pencil';
import Refresh from './Refresh';
import UsageLimits from './UsageLimits';
import BankIcon from './BankIcon';
import BackLeftIcon from './BackLeftIcon';

export { NextIcon, CartAdd, BackIcon, Star, NoteIcon, CloseIcon, DropdownClosedIcon, DropdownOpenedIcon, RoundedCloseIcon, ArrowLeft, Cart, ItemsIcon, CarIcon, ArrowRight, TrashIcon, ThreeDots, Pencil, Crop, Refresh, UsageLimits, BankIcon, BackLeftIcon };


// WEBPACK FOOTER //
// ./src/icons/index.jsx